<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Transferências em Espera</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="responsiblesLoaded == 'not_loaded'">Carregando beneficiários...</div>
          <div v-if="responsiblesLoaded == 'error'">Algo errado. Não foi possível carregar os beneficiários.</div>
          <div v-if="responsiblesLoaded == 'not_authorized'">Não foi possível carregar as beneficiários. Você não foi autorizado.</div>
          <div v-if="responsiblesLoaded == 'empty'">Não existem transferências em espera neste momento.</div>
          <transition name="fade">
            <v-card class="mb-3" style="border-radius: 10px;" v-if="responsiblesLoaded == 'ok' && bankAccountsLoaded == 'ok'">
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 sm7 py-0 text-xs-left text-sm-left pt-1>
                    <div class="font-weight-thin">
                      Saldo Genial: {{ this.integrationBalance["genial"] }}
                      <span @click="getIntegrationBalance('Genial', 'genial')" class="balance-button ml-2">
                        Atualizar saldo
                      </span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm7 py-0 text-xs-left text-sm-left pt-1>
                    <div class="font-weight-thin">
                      Saldo Facilita Bank: {{ this.integrationBalance["facilita_bank"] }}
                      <span @click="getIntegrationBalance('Facilita Bank', 'facilita_bank')" class="balance-button ml-2">
                        Atualizar saldo
                      </span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm7 py-0 text-xs-left text-sm-left pt-1>
                    <div class="font-weight-thin">
                      Saldo STP: {{ this.integrationBalance["stp"] }}
                      <span @click="getIntegrationBalance('STP', 'stp')" class="balance-button ml-2">
                        Atualizar saldo
                      </span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm7 py-0 text-xs-left text-sm-left pt-1>
                    <div class="font-weight-thin">
                      Saldo Cobre: {{ this.integrationBalance["cobre"] }}
                      <span @click="getIntegrationBalance('Cobre', 'cobre')" class="balance-button ml-2">
                        Atualizar saldo
                      </span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>
                    <div class="font-weight-thin">
                      <span @click="downloadCsv" class="nowrap subtitle rounded-chip mr-3" v-if="exchangesLoaded == 'ok'">
                        Download CSV
                      </span>
                      Registros: {{ responsibles.length }}
                    </div>
                  </v-flex>
                  <v-flex xs12 pa-0>
                    <v-text-field v-model="responsiblesFilter" class="search-filter" append-icon="search"></v-text-field>
                  </v-flex>

                  <account-item @wireCreated="wireCreated" :bank_accounts="bankAccounts" :record="responsible" v-for="responsible in responsibles" :key="responsible.ref" />
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-layout column>
                  <v-flex xs12>
                    <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style">
                      EXIBIR MAIS
                    </v-btn>
                    <slot></slot>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import utils from "./shared/Utils"
import LeftBarLayout from "./layouts/LeftBarLayout"
import WireAccountItem from "./WireAccountItem"
import { BankAccountsApi } from '@/shared/BankAccountsApi'

export default {
  name: 'AdminWireByReceiver',
  components: { layout: LeftBarLayout, 'account-item': WireAccountItem },
  data: () => {
    return {
      navItems: [{ url: '/admin/exchange/list', title: 'Operações de Câmbio', icon: 'dashboard' }],
      bankAccounts: [],
      responsibles: [],
      showMoreBtn: false,
      bankAccountsLoaded: 'not_loaded',
      responsiblesLoaded: 'not_loaded',
      exchangesLoaded: 'not_loaded',
      responsiblesFilter: '',
      integrationBalance: { "genial": "0.0", "facilita_bank": "0.0", "stp": "0.0", "cobre": "0.0" }
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadResponsibles()
    this.loadBankAccounts()
    this.getIntegrationBalance("Genial", "genial")
    this.getIntegrationBalance("Facilita Bank", "facilita_bank")
    this.getIntegrationBalance("STP", "stp")
    this.getIntegrationBalance("Cobre", "cobre")
  },
  methods: {
    createReferenceFromWire(receiver_id, exchange_ids, wire) {
      if (exchange_ids.length == 1) {
        return exchange_ids[0]
      }
      return receiver_id + exchange_ids.length + wire.value
    },
    createReference(item) {
      if (item.count == 1) {
        return item.exchange_ids[0]
      }
      return item.receiver.id + item.count + item.value
    },
    wireCreated(receiver_id, exchange_ids, wire_data) {
      this.responsibles.splice(this.responsibles.findIndex(el => el.ref === this.createReferenceFromWire(receiver_id, exchange_ids, wire_data)), 1)
      if (this.responsibles.length === 0) {
        this.responsiblesLoaded = 'empty'
      }
    },
    accountSelect(currency) {
      let bank_accounts = this.bankAccounts.filter((record) => { return record.currency == currency })
      return bank_accounts.map(o => { return { text: `${o.bank.name} ${o.branch_number} ${o.account_number}`, value: `${o.id}` } })
    },
    loadBankAccounts() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.bankAccounts = response.body.data
          this.bankAccountsLoaded = 'ok'
        } else {
          this.bankAccountsLoaded = 'error'
          console.log('successCallback', response)
          debugger
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.bankAccountsLoaded = 'not_authorized'
        } else {
          this.bankAccountsLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      BankAccountsApi.onlyGet(this, this.$root.urls.admin__payout_bank_accounts, successCallback, errorCallback);
    },
    loadResponsibles() {
      let putReference = (item) => {
        item.ref = this.createReference(item)
        return item
      }
      let successCallback = (response) => {
        if (response.body.data) {
          this.responsibles = response.body.data.map(putReference);

          if (this.responsibles.length === 0) {
            this.responsiblesLoaded = 'empty'
          } else {
            this.responsiblesLoaded = 'ok'
          }
          this.loadExchanges()
        } else {
          this.responsiblesLoaded = 'error'
          console.log('successCallback', response)
          debugger
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.responsiblesLoaded = 'not_authorized'
        } else {
          this.responsiblesLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      this.responsiblesLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin__bank_transactions__for_wire, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    loadExchanges() {
      let successCallback = (response) => {
        if (response.body.data) {
          const exchanges = response.body.data
          this.responsibles = this.responsibles.map(r => {
            r.exchanges = r.exchange_ids.map(id => {
              return exchanges[exchanges.findIndex(el => el.id === id)]
            })
            return r
          })
          this.exchangesLoaded = 'ok'
        } else {
          this.exchangesLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.exchangesLoaded = 'not_authorized'
        } else {
          this.exchangesLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      this.exchangesLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      let exchange_ids = this.responsibles.reduce((acc, r) => { return r.exchange_ids.reduce((acc, id) => { acc.push(id); return acc }, acc) }, [])
      const payload = { exchange_ids: exchange_ids }
      this.$http.post(this.$root.urls.admin__load_exchanges, payload, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    downloadCsv() {
      const parseDocument = (company) => {
        if (!company || !company.document_type || !company.document_number) return '';
        return utils.mask(company.document_type, company.document_number);
      };

      const header_line = [
        'IDENTIFICATION_DATE',
        'EXCHANGE_DATE',
        'CURRENCY',
        'VALUE',
        'TRANSACTIONS',
        'NAME',
        'DOCUMENT_NUMBER',
        'RECEIVER_ADDRESS',
        'BANK_NAME',
        'BANK_CODE',
        'BRANCH_NUMBER',
        'ACCOUNT_NUMBER',
        'ACCOUNT_TYPE',
      ];

      const rows = this.responsibles.reduce((rows, responsible) => {
        const exchange = (Array.isArray(responsible.exchanges) && responsible.exchanges.length > 0)
          ? responsible.exchanges[0]
          : {};

        const bankTransaction = (Array.isArray(exchange.bank_transactions) && exchange.bank_transactions.length > 0)
          ? exchange.bank_transactions[0]
          : {};

        const receiver = responsible.receiver || {};
        const company = receiver.company || {};
        const bank = receiver.bank || {};

        const row = [
          utils.dbDateTimeToHuman(bankTransaction.inserted_at),
          utils.dbDateTimeToHuman(exchange.inserted_at),
          receiver.currency || '',
          responsible.value,
          responsible.count || '',
          utils.parseCommaField(company.social_name) || '',
          parseDocument(company),
          utils.addressFormated(company) || '',
          utils.parseCommaField(bank.name) || '',
          utils.parseCommaField(bank.code) || '',
          receiver.branch_number || '',
          utils.formatLargeNumberAsText(receiver.account_number) || '',
          receiver.account_type || ''
        ];

        rows.push(row);
        return rows;
      }, [header_line]);

      utils.exportToCsv('pending-wires.csv', rows, ';');
    },
    getIntegrationBalance(label, integrationName) {
      let successCallback = (response) => {
        if (response.body.data && response.body.data.balance) {
          switch (integrationName) {
            case "stp":
              this.integrationBalance[integrationName] = utils.currencyToLocal(response.body.data.balance, "MXN")
              break;
            case "cobre":
              this.integrationBalance[integrationName] = utils.currencyToLocal(response.body.data.balance, "COP")
              break;
            default:
              this.integrationBalance[integrationName] = utils.currencyToLocal(response.body.data.balance, "BRL")
              break;
          }
        } else {
          this.integrationBalance[integrationName] = `Não foi possível recuperar o saldo da ${label}`
        }
      }

      let errorCallback = (response) => {
        this.integrationBalance[integrationName] = `Não foi possível recuperar o saldo da ${label}`
      }

      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin__fx_bank_accounts_facilita_wire_bank_account.replace('FACILITA_WIRE_ACCOUNT_INTEGRATION_NAME', integrationName), { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
.disable-events {
  pointer-events: none;
}

.balance-button {
  background-color: #BCC1D1;
  border-radius: 10px;
  padding: 3px 10px 3px 10px;
  color: white;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/AdminWireByReceiver.vue